import { createRouter as createTanStackRouter, type RouterHistory } from '@tanstack/react-router';
import { routeTree } from './routeTree.gen';

export function createRouter(history?: RouterHistory) {
  return createTanStackRouter({
    routeTree,
    history,
    // Pages are full documents (links are plain <a> tags), matching the Webflow site.
    defaultPreload: false,
    scrollRestoration: false,
    trailingSlash: 'never',
  });
}

declare module '@tanstack/react-router' {
  interface Register {
    router: ReturnType<typeof createRouter>;
  }
}
